// extracted by mini-css-extract-plugin
export var boxItems = "_b2-1";
export var boxItemsLg = "_b2-2";
export var button = "_b2-7";
export var buttonHoverless = "_b2-9";
export var buttonLg = "_b2-8";
export var filterGroupBox = "_b2-0";
export var icon = "_b2-3";
export var iconSecondary = "_b2-6";
export var iconWrapper = "_b2-4";
export var iconWrapperLg = "_b2-5";
export var truncatedLabel = "_b2-a";